export default __webpack_public_path__ + "static/media/caret-down-dark.b749c2ef.svg";